import React from 'react';
import { useSocketContext } from './SocketContext';
import {
  SocketHandlerFunction,
  SocketNotificationHandlerFunction,
  WebSocketEventType,
} from '$/components/Socket/ChatSocket';
import { logger } from '$/utils/logger';

interface EventProps {
  handler: SocketNotificationHandlerFunction;
  connected?: () => void;
}

export const MessageEvent: React.FC<EventProps> = ({ handler, connected }) => {
  const { socket } = useSocketContext();

  React.useEffect(() => {
    if (!socket?.on || !socket?.off) {
      logger.warn('Socket IO connection has not been established.', { socket });
      return;
    }

    if (connected) {
      socket.on(WebSocketEventType.open, connected as any as SocketHandlerFunction);
    }
    socket.on(WebSocketEventType.message, handler as any as SocketHandlerFunction);
    return (): void => {
      if (connected) {
        socket.off(WebSocketEventType.open, connected as any as SocketHandlerFunction);
      }
      socket.off(WebSocketEventType.message, handler as any as SocketHandlerFunction);
    };
  }, [socket, handler, connected, socket?.ws]);

  return null;
};

export default MessageEvent;
